module.exports = __webpack_public_path__ + "files/echo.ff15f40b9a18ef7987f8202ecb4e891a.pdf";